import { render, staticRenderFns } from "./StripeElementsSplitted.vue?vue&type=template&id=729666d5&scoped=true&"
import script from "./StripeElementsSplitted.vue?vue&type=script&lang=js&"
export * from "./StripeElementsSplitted.vue?vue&type=script&lang=js&"
import style0 from "./StripeElementsSplitted.vue?vue&type=style&index=0&id=729666d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729666d5",
  null
  
)

export default component.exports